/** 消息中心 */
import { NotifyMessageTypes } from "~/types/messages";

// 消息列表分页; /api/v1/message-server/page - GET
export interface IMessagePageParams {
  pageNo: Number;
  pageSize: Number;
  templateType?: NotifyMessageTypes;
  clearReadState: Boolean;
  langCode: String;
}
export const messagePage = (params: IMessagePageParams) =>
  useGet("/api/v1/message-server/page", params);

// 消息设置; /api/v1/message-server/setting - PUT
export interface IMessageSettingParams {
  messageNotify: Number;
  systemMessageNotify: Number;
  followingMessageNotify: Number;
  commentMessageNotify: Number;
  messageUnread: Boolean;
}
export const setMessageSetting = (params: IMessageSettingParams) =>
  usePut("/api/v1/message-server/setting", params);

// 获取消息设置状态; /api/v1/message-server/setting - GET
export const getMessageSetting = () => useGet("/api/v1/message-server/setting");

// 消息状态; /api/v1/message-server/state - GET
export const messageState = () => useGet("/api/v1/message-server/state");
